import React from "react";

import { Button, Typography } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import { withStyles } from "@material-ui/core/styles";

import SetupWarning from "./SetupWarning";

import SimpleTooltip, { SimpleTooltipPlacement } from "components/SimpleTooltip";

import {
    selectFiltersVisibility,
    showFilters,
    showSetupWarning
} from "modules/customer/tools/location/filters/filtersSlice";
import { selectTarget, selectPinnedLocation } from "modules/customer/tools/location/locationSlice";
import { useAppDispatch, useAppSelector } from "store";

const StyledButton = withStyles(theme => ({
    root: {
        marginLeft: theme.spacing(1),
        color: theme.palette.common.white,
        backgroundColor: theme.palette.background.default,
        borderColor: theme.palette.common.white,
        "&:hover": {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.background.default,
        }
    }
}))(Button);

const Open: React.FC = () => {
    const dispatch = useAppDispatch();
    const pinnedLocation = useAppSelector(selectPinnedLocation);
    const target = useAppSelector(selectTarget);
    const filtersVisibility = useAppSelector(selectFiltersVisibility);

    const handleClick = () => {
        if (!pinnedLocation) {
            dispatch(showFilters());
        } else {
            dispatch(showSetupWarning());
        }
    };

    return (
        <>
            <SimpleTooltip
                placement={SimpleTooltipPlacement.Bottom}
                title={
                    <Typography variant="subtitle1" component="div">
                        Complete setup to use the Location tool
                    </Typography>
                }
                open={!filtersVisibility.isVisible && !target}
                disableFocusListener={true}
                disableHoverListener={true}
                disableTouchListener={true}
            >
                <StyledButton
                    variant="outlined"
                    size="small"
                    color="default"
                    disableElevation
                    onClick={handleClick}
                    data-cy="btn-setup"
                >
                    <SettingsIcon />
                </StyledButton>
            </SimpleTooltip>
            <SetupWarning />
        </>
    );
};

export default Open;
